import styled from "styled-components";
import React from "react";

import { ValkLoader } from "styled";
import { flexCenter, fullVwVh, column, borderBox } from "components/common/mixins";
import { Label as BaseLabel } from "components/common/typography";

export const Wrapper = styled.section`
  display: flex;
  justify-content: space-between;
  width: 100vw;
  min-height: ${({ preview = false }) => (preview ? "calc(100vh - 80px)" : "100vh")};
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px ${({ theme: { inputsAutoFillBg } }) => inputsAutoFillBg} inset;
  }
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const Aside = styled.div`
  width: 470px;
  ${column}
  align-items: flex-start;
  padding: 50px 50px 60px;
  background: url(${({ bg }) => bg})
    ${({ isInvesture, theme: { authSidebar } }) => !isInvesture && `, ${authSidebar || "#1f263ec7"}`};
  background-blend-mode: soft-light, normal;
  box-sizing: border-box;
  background-position: center;
  background-size: cover;
  filter: grayscale(${({ theme: { greyFilter } }) => greyFilter});
  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

export const FormBlock = styled.div`
  ${column}
  align-items: center;
  box-sizing: border-box;
  padding: 30px 50px;
  width: calc(100% - 470px);
  background-color: ${({ infoPage }) => (infoPage ? "#f4f5f6" : "#fff")};
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 20px;
  }
`;

export const LogoBlock = styled.div`
  ${({ styles }) =>
    styles
      ? styles
      : `width: 310px;
         height: 42px;
         margin-bottom: 30px;
         > img {
           width: 100%;
         }`}
  @media(max-width: 768px) {
    display: none;
  }
`;

export const MobileLogoBlock = styled.div`
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  padding: 23px 20px;
  box-sizing: border-box;
  background: url(${({ bg }) => bg}) repeat center center;
  z-index: 3;
  display: flex;
  ${flexCenter}
  > img {
    width: 220px;
    height: 50px;
  }
`;

export const AsideText = styled.div`
  font-style: normal;
  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
  font-size: ${({ size }) => (size ? `${size}px` : "18px")};
  line-height: ${({ lineHeight = "145%" }) => lineHeight};
  color: ${({ white }) => (white ? "#fff" : "rgba(255, 255, 255, 0.7)")};
  margin: ${({ margin = 0 }) => margin};
  margin-bottom: ${({ mBottom }) => `${mBottom}px`};
  padding-right: ${({ pRight }) => `${pRight}px`};
  letter-spacing: ${(lc) => lc};
`;

export const BorderBlock = styled.div`
  width: 100%;
  padding: ${({ p = "60px 0" }) => p};
  box-sizing: border-box;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 50px;
  @media (max-width: 768px) {
    padding: 15px 0;
    margin-bottom: 15px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
`;

export const Step = styled.div`
  width: 40px;
  height: 5px;
  background: #ffffff;
  margin-right: 10px;
  opacity: ${({ active }) => (active ? 1 : 0.2)};
`;

export const SocialLink = styled.a`
  margin-right: 20px;
  transition: opacity 0.3s linear;
  svg {
    width: 32px;
    height: 32px;
  }
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    opacity: 0.7;
  }
  @media (max-width: 768px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const SmallScreenBg = styled.section`
  ${fullVwVh}
  background-color: #e5e5e5;
  display: flex;
  ${flexCenter}
  padding: 25px;
  ${borderBox}
`;

export const ScreenMess = styled.div`
  width: 100%;

  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 160%;
  color: #333333;
  text-align: center;
`;

export const GreyBg = styled.div`
  background-color: #f4f5f6;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 30px;
`;

//auth preview

const Column = styled.section`
  ${column}
  align-items: flex-start;
  box-sizing: border-box;
`;

export const PreviewLeft = styled(Column)`
  width: 470px;
  padding: 30px 50px 60px;
  background: url(${({ bg }) => bg}), ${({ theme: { authSidebar } }) => authSidebar || "#1f263ec7"};
  background-blend-mode: soft-light, normal;
  background-position: center;
  background-size: cover;
  filter: grayscale(${({ theme: { greyFilter } }) => greyFilter});
  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

export const Logo = styled.img`
  width: 325px;
  height: 75px;
  margin-bottom: 21px;
`;

export const Text = styled.p`
  font-weight: ${({ fWeight = "normal" }) => fWeight};
  font-size: ${({ size = "18" }) => `${size}px`};
  opacity: ${({ o = 1 }) => o};
  margin: ${({ m = "0 0 20px" }) => m};
  line-height: ${({ lHeight = 145 }) => `${lHeight}%`};
  color: #ffffff;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ isLink = false }) => (isLink ? "pointer" : "unset")};
`;

export const BottomBlock = styled(Column)`
  margin-top: auto;
`;

export const Row = styled.div`
  display: flex;
`;

const Layout = styled.section`
  background: rgba(0, 0, 0, 0.15);
  ${fullVwVh}
  display: flex;
  > * {
    margin: auto;
  }
`;

export const Loader = () => (
  <Layout>
    <ValkLoader />
  </Layout>
);

export const Label = styled(BaseLabel)`
  font-size: 12px;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.6);
  @media (max-width: 768px) {
    font-size: 8px;
    margin-bottom: 10px;
  }
`;
